/**
 * Set to true to restore the pre-tab sidebar (3 evaluator items nested under each content type).
 * Default: false — evaluators appear as in-page tabs (By Self / By Coach/Academy / By EncycGames).
 */
export const USE_LEGACY_RANKING_EVAL_SIDEBAR = false;
